/**
 * Normalize a studio asset serving path to the full, publicly-routable URL.
 *
 * Legacy drafts (persisted in localStorage) and old API responses stored
 * `/objects/studio/uuid.png`, which is not served by any route — in
 * production it falls through to the SPA static handler and returns
 * index.html, which breaks <img> rendering.
 *
 * The permanent route is `/api/storage/objects/...`. Idempotent for
 * already-correct paths.
 */
export function normalizeAssetUrl(url: string | null | undefined): string {
  if (!url) return "";
  if (url.startsWith("/objects/")) return `/api/storage${url}`;
  return url;
}
